import { z } from "zod";

const numericOrStringId = z.union([z.number(), z.string()]);

export const templateResponseSchema = z.object({
	templateId: z.number(),
	name: z.string(),
	typeEnum: z.string(),
	customerId: z.number(),
	userId: numericOrStringId,
	templateJson: z.string(),
	templateSchemaVersion: z.string().nullable().optional(),
	createdByUserId: numericOrStringId,
	createdDate: z.string(),
	lastModifiedByUserId: numericOrStringId,
	lastModifiedDate: z.string(),
});

export type TemplateResponse = z.infer<typeof templateResponseSchema>;

export const templateCreateSchema = z.object({
	name: z.string().min(1, "Template name is required"),
	typeEnum: z.string().default("Quote"),
	customerId: z.number(),
	userId: numericOrStringId.default(0),
	templateJson: z.string(),
});

export type TemplateCreateBody = z.infer<typeof templateCreateSchema>;

export const templateUpdateSchema = z.object({
	name: z.string().min(1, "Template name is required"),
	typeEnum: z.string().default("Quote"),
	customerId: z.number(),
	userId: numericOrStringId.default(0),
	templateJson: z.string(),
});

export type TemplateUpdateBody = z.infer<typeof templateUpdateSchema>;

export type TemplateGridItem = {
	templateId: number;
	templateName: string;
	shipperName: string;
	pickupStreet: string;
	pickupLocation: string;
	deliveryName: string;
	deliveryStreet: string;
	deliveryLocation: string;
	commodity: string;
	nmfc: string;
	freightClass: string;
	quantity: string;
	account: string;
	isFavorite?: boolean;
	isDefault?: boolean;
	raw: TemplateResponse;
};
